export interface DecodedJwtPayload {
  user_id?: number;
  [key: string]: unknown;
}

/**
 * Safely decode a JWT and return its JSON payload.
 * Returns null if decoding fails.
 */
export function parseJwt(token: string | null | undefined): DecodedJwtPayload | null {
  if (!token) return null;

  const parts = token.split(".");
  if (parts.length !== 3) return null;

  try {
    const payloadBase64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    const decoded = atob(payloadBase64);
    return JSON.parse(decoded);
  } catch (err) {
    console.warn("Failed to decode JWT", err);
    return null;
  }
}

/**
 * Determine if the given JWT represents a guest user (user_id === 0).
 * If the token is missing or invalid, we treat the user as guest.
 */
export function isGuestFromToken(token: string | null | undefined): boolean {
  const payload = parseJwt(token);
  if (!token || !payload) return true;
  if (typeof payload.user_id === "number" && payload.user_id === 0) return true;
  return false;
} 